module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/demo8/bg-1-0bf4526a00d5dff90b9d0caa690eea97.jpg";